<template>
    <div v-if="orden_compra">
        <h1 class="subtitle">Ordenes de Pago</h1>
        <div class="nj-cols">
            <OrdenCompraData :orden_compra="orden_compra"></OrdenCompraData>
            <div class="nj-card">
                <div class="nj-subtitle-1">Pagos</div>
                <div class="nj-flx">
                    <Button label="Regresar"
                            icon="leftArrow"
                            @click="regresar()"></Button>
                    <Button label="Buscar"
                            icon="find"
                            @click="buscarOrdenesPago()"></Button>
                    <Button label="Agregar"
                            icon="add"
                            @click="popup({ interfaz: 'agregar' })"
                            :activation="activarOpcion('agregar')"></Button>
                </div>
                <br>
                <b-table :data="ordenes_pago">
                    <template slot-scope="props">
                        <b-table-column class="order"
                                        label="N°"
                                        header-class="is-info">
                            {{ props.row.opg_numero | pad }}
                        </b-table-column>
                        <b-table-column label="Descripción"
                                        header-class="is-info">
                            {{ props.row.opg_descripcion }}
                        </b-table-column>
                        <b-table-column class="col"
                                        label="Proveedor"
                                        header-class="is-info">
                            {{ props.row.pve_razon_social }}
                        </b-table-column>
                        <b-table-column class="col right"
                                        label="Monto Total"
                                        header-class="is-info">
                            {{ props.row.opg_total | money(props.row.mon_simbolo) }}
                        </b-table-column>
                        <b-table-column class="col right"
                                        label="Detracción"
                                        header-class="is-info">
                            {{ props.row.opg_detraccion | money(props.row.mon_simbolo) }}
                        </b-table-column>
                        <b-table-column class="col right"
                                        label="Monto pagar"
                                        header-class="is-info">
                            {{ props.row.opg_pago | money(props.row.mon_simbolo) }}
                        </b-table-column>
                        <b-table-column class="col"
                                        label="Estado"
                                        header-class="is-info">
                            <b-tag :class="props.row.opg_estado_styles">
                                {{ props.row.opg_estado_nombre }}
                            </b-tag>
                        </b-table-column>
                        <b-table-column class="col"
                                        label="Aprobado por">
                            {{ props.row.opg_aprobador_nombre }}
                        </b-table-column>
                        <b-table-column class="col"
                                        label="Sistema Pago">
                            {{ props.row.opg_sistema_pago_nombre }}
                        </b-table-column>
                        <b-table-column class="col"
                                        label="Cierre">
                            {{ aplicoCierre(props.row) }}
                        </b-table-column>
                        <b-table-column class="col center"
                                        label="Opciones"
                                        header-class="is-info">
                            <div class="nj-flex">
                                <Button title="Ver"
                                        icon="info"
                                        @click="popup({ interfaz: 'ver', opg_id: props.row.opg_id })">
                                </Button>
                                <Button title="Modificar"
                                        icon="edit"
                                        @click="popup({ interfaz: 'modificar', opg_id: props.row.opg_id })"
                                        :activation="activarOpcion('modificar', props.row)">
                                </Button>
                                <Button title="Solicitar aprobacion"
                                        icon="email"
                                        @click="solicitarAprobacion(props.row.opg_id)"
                                        :activation="activarOpcion('solicitarAprobacion', props.row)">
                                </Button>
                                <Button title="Eliminar"
                                        icon="delete"
                                        color="red"
                                        @click="eliminar(props.row.opg_id)"
                                        :activation="activarOpcion('eliminar', props.row)">
                                </Button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <RegistrarOrdenPago v-if="interfaz == 'agregar'"
                            @close="popup($event)"
                            :ord_id="ord_id"></RegistrarOrdenPago>
        <VerOrdenPago v-if="interfaz == 'ver'"
                      @close="popup($event)"
                      :opg_id="opg_id"></VerOrdenPago>
        <ModificarOrdenPago v-if="interfaz == 'modificar'"
                            @close="popup($event)"
                            :opg_id="opg_id"></ModificarOrdenPago>
    </div>
</template>

<script>
import { CondicionComercialEnum, EstadoEnum, OrdenEstadoEnum } from "../../constants"
import { OrdenCompraService, ResponseStatus } from "../../services"
import OrdenPagoService from "../../services/OrdenPagoService"
import { Confirm, Tools } from "../../util"
import Toast from "../../util/toast"
import { Box, Button } from "../components"
import ModificarOrdenPago from "./ModificarOrdenPago.vue"
import OrdenCompraData from "./OrdenCompraData.vue"
import RegistrarOrdenPago from "./RegistrarOrdenPago.vue"
import VerOrdenPago from "./VerOrdenPago.vue"

export default {
    name: "OrdenPago",
    components: {
        OrdenCompraData,
        Button,
        Box,
        RegistrarOrdenPago,
        VerOrdenPago,
        ModificarOrdenPago,
    },
    data() {
        return {
            ordenes_pago: [],
            ord_id: parseFloat(this.$route.params.ord_id),
            orden_compra: null,
            interfaz: "none"
        }
    },
    methods: {
        popup({
            interfaz,
            opg_id,
            buscar_ordenes_pago,
            buscar_datos_orden,
        }) {
            this.interfaz = interfaz
            this.opg_id = opg_id
            if (buscar_ordenes_pago) {
                this.buscarOrdenesPago()
            }
            if (buscar_datos_orden) {
                this.obtenerOrdenCompra()
            }
        },
        aplicoCierre(orden_pago) {
            return orden_pago.opg_pago_cierre == 1 ? "SI" : "NO"
        },
        activarOpcion(opcion, orden_pago = null) {
            let condicion = false
            switch (opcion) {
                case "modificar":
                    condicion = true
                    break
                case "solicitarAprobacion":
                    condicion = orden_pago.opg_estado == EstadoEnum.CREADO.est_codigo || orden_pago.opg_estado == EstadoEnum.POR_APROBAR.est_codigo
                    break
                case "eliminar":
                    condicion = orden_pago.opg_estado == EstadoEnum.CREADO.est_codigo || orden_pago.opg_estado == EstadoEnum.POR_APROBAR.est_codigo || orden_pago.opg_estado == EstadoEnum.APROBADO
                    break
                case "agregar":
                    // si esta aprobado y es a credito o adelanto
                    condicion =
                        (this.orden_compra.ore_id == OrdenEstadoEnum.APROBADO.id || this.orden_compra.ore_id == OrdenEstadoEnum.EMITIDO.id)
                        && (this.orden_compra.coc_id == CondicionComercialEnum.CREDITO.coc_id || this.orden_compra.coc_id == CondicionComercialEnum.ADELANTO.coc_id)
                    break
            }
            return condicion
        },
        eliminar(opg_id) {
            Confirm.show({
                message: "¿Desea eliminar la orden de pago?",
                action: () => {
                    OrdenPagoService
                        .eliminar({
                            orden_pago: {
                                opg_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscarOrdenesPago()
                                this.obtenerOrdenCompra()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        solicitarAprobacion(opg_id) {
            Confirm.show({
                message: "¿Desea solicitar la aprobacion de la orden de pago?",
                action: () => {
                    OrdenPagoService
                        .solicitarAprobacion({
                            orden_pago: {
                                opg_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscarOrdenesPago()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        regresar() {
            this.$router.push({
                name: "OrdenView",
                params: {
                    id: this.ord_id
                }
            })
        },
        obtenerOrdenCompra() {
            OrdenCompraService
                .obtener({
                    orden_compra: {
                        ord_id: this.ord_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.orden_compra = response.data
                        this.buscarOrdenesPago()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        buscarOrdenesPago() {
            OrdenPagoService
                .buscar({
                    orden_pago: {
                        ord_id: this.orden_compra.ord_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.ordenes_pago = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        }
    },
    mounted() {
        this.obtenerOrdenCompra()
        if (this.$route.params.interfaz && this.$route.params.opg_id) {
            this.popup({
                interfaz: this.$route.params.interfaz,
                opg_id: parseInt(this.$route.params.opg_id)
            })
        }
    }
}
</script>